import { createSelector } from 'reselect';

import { extractRequestable } from '~/utils/fetchable';

import { type ApplicationState } from '../store';

const getTrackingSettingsStore = (state: ApplicationState) => state.trackingSettings;

export const getTrackingConfig = createSelector(
  getTrackingSettingsStore,
  (store) =>
    extractRequestable(store.trackingConfig) || {
      recommendationTitle: null,
      recommendationTitleTracking: null,
      returnPolicySource: null,
      returnPolicyUrl: null,
      spotlightTitle: null,
    },
);

export const getTrackingConfigIsLoading = createSelector(
  getTrackingSettingsStore,
  (store) => store.trackingConfig.kind === 'requesting',
);

export const getTrackingConfigUpdateRequest = createSelector(
  getTrackingSettingsStore,
  (store) => store.trackingConfigUpdateRequest,
);

export const getBrandAndFooterUpdateStatus = createSelector(
  getTrackingSettingsStore,
  (store) => store.brandAndFooterUpdateRequest.kind,
);
